import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {WorkflowId} from "common/flowmaster/types/workflow";
import {Test, TestId} from "common/flowmaster/types/test";

export type WorkflowTestDeleteAction = {
  type: WorkflowsActionTypes["WORKFLOW_TEST_DELETE"]["SUCCESS"];
  payload: {links: Record<string, unknown>; tests: Test[]};
};

export default function deleteWorkflowTest(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TEST_DELETE,
    (
      organisationId: OrganisationId,
      workflowContextId: WorkflowId,
      testId: TestId,
    ) => {
      return requestor
        .delete(
          `${basePath}/organisation/${organisationId}/workflow_context/${workflowContextId}/test/${testId}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
